import React, { useState, useEffect, Suspense, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { complaintmodel } from '../../models/complaints/complaint-model';
import { Button } from 'primereact/button';
import { Toast } from "primereact/toast";
import { complaintExport } from '../Complaint/complaint-list-export';
import ComplaintService from '../../services/complaint/ComplaintService';
import AppLoading from '../app-loading/app-loading';
import { complaintsExport } from './complaints-list-export';
import { complaintmodel2 } from '../../models/complaints/complaint-model';
import CustomerComplaintDataTable from './CustomerComplaintDataTable';
import CustomerComplaintSearch from './CustomerComplaintSearch';
// import CustomerComplaintSearch from './CustomerComplaintSearch';

const CustomerComplaintMain: React.FC = () => {
  const toast = useRef<Toast>(null);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [filteredComplaints, setFilteredComplaints] = useState<complaintmodel[]>([]);
  const [complaintList, setComplaintList] = useState<complaintmodel[]>([]);
  const [updatedData, setUpdatedData] = useState<complaintmodel2[]>([]);
  const [pageNo, setPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [pageSize, setPageSize] = useState(10);
  const [complaintType, setComplaintType] = useState<'product' | 'service'>('product');

  const [filters, setFilters] = useState<any>({
    complaintType: 'product',
    startDate: null,
    endDate: null,
    customerID: null
  });

  useEffect(() => {
    const loadComplaints = async () => {
      setLoading(true);
      try {
        let response;
        if (filters.complaintType === 'product') {
          response = await ComplaintService.GetAllCustProductComplaints();
        } else {
          response = await ComplaintService.GetAllCustServiceComplaints();
        }

        let initialFiltered = [...response];

        if (filters.startDate && filters.endDate) {
          initialFiltered = initialFiltered.filter(complaint => {
            const complaintDate = new Date(complaint.createdDate);
            return complaintDate >= filters.startDate &&
              complaintDate <= filters.endDate;
          });
        }

        if (filters.customerID) {
          const searchTerm = filters.customerID.toString().toLowerCase();
          initialFiltered = initialFiltered.filter(complaint => {
            const customerIdStr = complaint.customerId?.toString().toLowerCase() || '';
            const mobileStr = complaint.mobile?.toString().toLowerCase() || '';
            const customerNameStr = complaint.customerName?.toLowerCase() || '';
            return customerIdStr.includes(searchTerm) ||
              mobileStr.includes(searchTerm) ||
              customerNameStr.includes(searchTerm);
          });
        }

        setComplaintList(response);
        setFilteredComplaints(initialFiltered);
        setTotalRecords(initialFiltered.length);
      } catch (error) {
        console.error('Error loading complaints:', error);
        setComplaintList([]);
        setFilteredComplaints([]);
        setTotalRecords(0);
      } finally {
        setLoading(false);
      }
    };

    loadComplaints();
  }, [pageNo, pageSize, filters]);

  const handleSearch = (searchFilters: any) => {
    setPageNo(1);

    const isDateEmpty = !searchFilters.startDate && !searchFilters.endDate;
    const isCustomerEmpty = !searchFilters.customerID;

    setComplaintType(searchFilters.complaintType || 'product');
    setFilters({
      ...searchFilters,
      complaintType: searchFilters.complaintType || 'product'
    });

    // If no filters are applied, show all
    if (isDateEmpty && isCustomerEmpty) {
      setFilteredComplaints(complaintList);
      setTotalRecords(complaintList.length);
      return;
    }

    if (complaintList.length > 0) {
      let filtered = [...complaintList];

      if (!isDateEmpty) {
        filtered = filtered.filter(complaint => {
          const complaintDate = new Date(complaint.createdDate);
          return complaintDate >= searchFilters.startDate &&
            complaintDate <= searchFilters.endDate;
        });
      }

      if (!isCustomerEmpty) {
        const searchTerm = searchFilters.customerID.toString().toLowerCase();
        filtered = filtered.filter(complaint => {
          const customerIdStr = complaint.customerId?.toString().toLowerCase() || '';
          const mobileStr = complaint.mobile?.toString().toLowerCase() || '';
          const customerNameStr = complaint.customerName?.toLowerCase() || '';
          return customerIdStr.includes(searchTerm) ||
            mobileStr.includes(searchTerm) ||
            customerNameStr.includes(searchTerm);
        });
      }

      setFilteredComplaints(filtered);
      setTotalRecords(filtered.length);
    }
  };

  const handlePageChange = (event: any) => {
    const newPageNumber = Math.floor(event.first / event.rows) + 1;
    setPageNo(newPageNumber);
    setPageSize(event.rows);
  };

  const hadelNewDate = (updatedComplaint: complaintmodel2) => {
    const updateSingle = (list: any[]) => list.map(complaint =>
      complaint.id === updatedComplaint.id
        ? { ...complaint, ...updatedComplaint }
        : complaint
    );

    setComplaintList(prev => updateSingle(prev));
    setFilteredComplaints(prev => updateSingle(prev));
  };

  const handelComplaintList = (params: complaintmodel[]) => {
    setComplaintList(params);
    setFilteredComplaints(params);
  };

  return (
    <>
      <Suspense fallback={<AppLoading />}>
        <Toast ref={toast} position="top-center" />
        <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
          <div className="col-12">
            <CustomerComplaintSearch
              onSearch={handleSearch}
              setLoading={setLoading}
              setNewData={hadelNewDate}
              initialDates={filters.dateRange}
            />
          </div>

          <CustomerComplaintDataTable
            data={filteredComplaints}
            updatedData={hadelNewDate}
            complaintList={handelComplaintList}
            pageNo={pageNo}
            pageSize={pageSize}
            handlepagechange={handlePageChange}
            totalRecordsCount={totalRecords}
            complaintType={complaintType}
          />
        </div>
        {loading && <AppLoading />}
      </Suspense>
    </>
  );
};

export default CustomerComplaintMain;
